import { Box, Typography } from '@mui/material';
import { Link } from '@tanstack/react-router';
import { platformPuffinLogo } from '@puffin/ui-library';

export const AppBrand = ({ compact = false }: { compact?: boolean }) => (
  <Box
    component={Link}
    to="/"
    aria-label="Meisterplan Dev Platform home"
    sx={{ color: 'inherit', textDecoration: 'none', display: 'flex', alignItems: 'center', gap: 1.25 }}
  >
    <Box component="img" src={platformPuffinLogo} alt="" sx={{ width: 38, height: 38 }} />
    {!compact && (
      <Typography variant="subtitle1" noWrap sx={{ fontWeight: 700 }}>
        MP Dev Platform
      </Typography>
    )}
  </Box>
);
